define('core/utils/object/has',[],function () {
    'use strict';

    return function has(obj, key) {
        // The object.hasOwnProperty method fails when the
        // property under consideration is named 'hasOwnProperty'.
        return Object.prototype.hasOwnProperty.call(obj, key);
    };
});

